module.exports = __webpack_public_path__ + "static/media/user_account_variant.eb4a2aca.svg";